import type { WorkflowStepDeclaration } from './platform-workflow-definition-lifecycle.models';
type Detail = WorkflowStepDeclaration['detail'];
export type PageTab = NonNullable<Detail['tabs']>[number];

export function enablePageTabs(detail: Detail): Detail {
  if (detail.tabs?.length) return detail;
  return { ...detail, tabs: [{ id: 'main', label: 'Main content' }, { id: 'information', label: 'Supporting information' }],
    formTabId: 'main', blocks: detail.blocks.map(block => block.region === 'main' ? { ...block, tabId: 'main' } : block) };
}
export function setPageTabs(detail: Detail, tabs: PageTab[]): Detail {
  if (tabs.length > 8 || tabs.some(tab => !tab.label.trim() || tab.label !== tab.label.trim() || tab.label.length > 80)
    || new Set(tabs.map(tab => tab.label.toLowerCase())).size !== tabs.length)
    throw new Error('Use up to eight tabs with distinct titles of 1–80 characters.');
  const { formTabId } = detail;
  const rest = { ...detail }; delete rest.tabs; delete rest.formTabId;
  const fallback = tabs[0]?.id;
  const existing = new Set(tabs.map(tab => tab.id));
  return { ...rest, ...(tabs.length ? { tabs, formTabId: existing.has(formTabId ?? '') ? formTabId : fallback } : {}),
    blocks: detail.blocks.map(block => {
      if (block.region !== 'main') return block;
      const { tabId, ...content } = block;
      return { ...content, ...(fallback ? { tabId: existing.has(tabId ?? '') ? tabId : fallback } : {}) };
    }) };
}
